// extracted by mini-css-extract-plugin
export default {"card":"Card_card__yJdSy","content":"Card_content__e7K+V","closeButton":"Card_closeButton__Xix95"};